import {ref} from "vue";

export default function useXLSXHeaderReference() {
    const headers = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "AA",
        "AB",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AH",
        "AI",
        "AJ",
        "AK",
        "AL",
        "AM",
        "AN",
        "AO",
        "AP",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AV",
        "AW",
        "AX",
        "AY",
        "AZ",
    ];
    const headerExample = ref({
        A: null,
        B: null,
        C: null,
        D: null,
        E: null,
        F: null,
        G: null,
        H: null,
        I: null,
        J: null,
        K: null,
        L: null,
        M: null,
        N: null,
        O: null,
        P: null,
        Q: null,
        R: null,
        S: null,
        T: null,
        U: null,
        V: null,
        W: null,
        X: null,
        Y: null,
        Z: null,
        AA: null,
        AB: null,
        AC: null,
        AD: null,
        AE: null,
        AF: null,
        AG: null,
        AH: null,
        AI: null,
        AJ: null,
        AK: null,
        AL: null,
        AM: null,
        AN: null,
        AO: null,
        AP: null,
        AQ: null,
        AR: null,
        AS: null,
        AT: null,
        AU: null,
        AV: null,
        AW: null,
        AX: null,
        AY: null,
        AZ: null,
    });
    const address = ref({
        A: null,
        B: null,
        C: null,
        D: null,
        E: null,
        F: null,
        G: null,
        H: null,
        I: null,
        J: null,
        K: null,
        L: null,
        M: null,
        N: null,
        O: null,
        P: null,
        Q: null,
        R: null,
        S: null,
        T: null,
        U: null,
        V: null,
        W: null,
        X: null,
        Y: null,
        Z: null,
        AA: null,
        AB: null,
        AC: null,
        AD: null,
        AE: null,
        AF: null,
        AG: null,
        AH: null,
        AI: null,
        AJ: null,
        AK: null,
        AL: null,
        AM: null,
        AN: null,
        AO: null,
        AP: null,
        AQ: null,
        AR: null,
        AS: null,
        AT: null,
        AU: null,
        AV: null,
        AW: null,
        AX: null,
        AY: null,
        AZ: null,
    });

    return {
        headers,
        headerExample,
        address,
    }
}